<script>
import LinkLayoutA from './LinkLayouts/A.svelte';
import LinkLayoutB from './LinkLayouts/B.svelte';
import LinkLayoutC from './LinkLayouts/C.svelte';
import LinkLayoutD from './LinkLayouts/D.svelte';

export let key;
export let column;
export let headline = '';
export let description = '';
export let what = null;
export let tools = null;
export let image = null;
export let video = null;
export let url;
export let layout = 'A';
export let isMobile = false;
export let where = null;
export let maxWidth = null;

const info = { headline, description, video, image, what, tools, where, maxWidth };

let linkLayout = LinkLayoutA;
$: {
    if (isMobile) {
        if (layout === 'A') linkLayout = LinkLayoutA;
        else if (layout === 'B') linkLayout = LinkLayoutA;
        else if (layout === 'C') linkLayout = LinkLayoutC;
        else if (layout === 'D') linkLayout = LinkLayoutD;
        else linkLayout = LinkLayoutA;
    } else {
        if (layout === 'A') linkLayout = LinkLayoutA;
        else if (layout === 'B') linkLayout = LinkLayoutB;
        else if (layout === 'C') linkLayout = LinkLayoutC;
        else if (layout === 'D') linkLayout = LinkLayoutD;
        else linkLayout = LinkLayoutA;
    }
}
</script>

<style>
.link {
    display: block;
    color: inherit;
    position: relative;
    padding: 0.5em 0.75em;
    box-sizing: border-box;
}

.link + .link {
    margin-top: 2em;
}

.link + .link:after {
    content: '';
    width: 100%;
    position: absolute;
    top: -1em;
    left: 0px;
    border-bottom: 1px solid #e3e3e3;
}

.link :global(.headline),
.link :global(.description) {
    transition: opacity 0.25s;
}

.link:hover {
    text-decoration: none;
}

.link:hover :global(.headline),
.link:hover :global(.description) {
    opacity: 0.8;
}

.link :global(.headline) {
    font-weight: bold;
    margin-bottom: 0.5em;
}

.link :global(.description) {
    font-size: 75%;
    line-height: 1.4;
}

.link :global(img),
.link :global(video) {
    margin: 0.5em;
    border-radius: 1px;
}

.link :global(.what),
.link :global(.tools),
.link :global(.where) {
    font-size: 60%;
    font-family: 'Lato', sans-serif;
    color: #666;
    margin: 1em 0px;
}

</style>

<a class="link" href="{url}">
    <svelte:component this={linkLayout} {...info} />
</a>
